export const BuildFormRows = (form) => {
  const splitArr = Object.keys(form).reduce((acc, curr, i) => {
    if ( !(i % 2)  ) {
      if (form[curr]?.fullcolumn) {
        // even and full col
        acc.push([Object.keys(form)[i]]);
      }
      else if (form[Object.keys(form)[i + 1]]?.fullcolumn)  {
        // even and next is full col
        acc.push([Object.keys(form)[i]]);
        acc.push([Object.keys(form)[(i + 1)]]);
      }
      else {
        // even and neither is full col
        acc.push(Object.keys(form).slice(i, i + 2));
      }
    }
    return acc;
  }, []);
  
  return splitArr
}

export const ValidateForm = {
  BlockedTimeForm: values => {
    let errors = {};

    if (values.endTime <= values.startTime) {
      errors.endTime = 'End time must be greater than start time';
    }

    return errors
  },
  BookingForm: values => {
    let errors = {};

    if (!values.firstName) {
      errors.firstName = 'Required';
    }
    
    if (!values.lastName) {
      errors.lastName = 'Required';
    }

    if (!values.email) {
      errors.email = 'Required';
    }

    return errors;
  }
}
